import './templateRow.css'
import React from 'react'

import { Delete } from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import { AlertDialog } from '../alertdialog/AlertDialog'
import {useState} from "react";

export const TemplateRow = ({ chat, deleteHandler, clickHandler, setExpand, setTemplateName  }) => {
    
    const [openDialog, handleDisplay] = useState(false);
    const [dialogtext, setDialogText] = useState('');

    let {
        changeLanguage,
      } = React.useContext(StatusContext);

      const alertYes = () => {
        closeDialogBox()
        deleteHandler(chat)
      }

      const alertCancel = () => {
        closeDialogBox()
      }

      const openDialogBox = () => {
        handleDisplay(true);
     };
      const closeDialogBox = () => {
        handleDisplay(false);
     };

     const handleDelete = () => {
        console.log("handle Delete")

        setDialogText(`${changeLanguage('status', 'deletetopic')} '${chat.chatname}'?`)
      
        openDialogBox()
       
    }

    return (
        <div className="templateListItem" key={chat.id}>
             {
               
                <Delete className="promptIcon" onClick={()=>{ handleDelete()}} />
            }
            
            <li
                
                className="templateName"
                onClick={() => { clickHandler(chat); setExpand(); setTemplateName(chat.chatname) }}>
                
               {chat.chatname}
                
            </li>
            
            <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogtext}/>
        </div>
    )
}